import React from 'react';

const UserTypeOptions = ({ icon, heading, isActive, onClick }) => {
  return (
    <div
      role="button"
      className={`title-selection-innner mb-3 ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        <div className="option-icon me-3">
        {/* <img src={icon} alt={`${heading} Icon`} /> */}
        </div>
        <span className="option-text">{heading}</span>
      </div>
    </div>
  );
};

export default UserTypeOptions;
